<template>
  <div>
    <a-card :bordered="false" title="项目余额（辅助核算余额）">
      <div class="table-page-search-wrapper">
        <a-form layout="inline" @keyup.enter.native="searchQuery">
          <a-row :gutter="24">
            <a-col :md="6" :sm="24">
              <a-form-item label="辅助维度" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-select v-model="categoryId" @change="searchQuery">
                  <a-select-option v-for="d in dimensions" :key="d.id" :value="d.id">{{ d.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24"><a-form-item label="起始月份" :labelCol="labelCol" :wrapperCol="wrapperCol"><a-month-picker v-model="beginMoment" format="YYYY-MM" style="width:100%" /></a-form-item></a-col>
            <a-col :md="6" :sm="24"><a-form-item label="截止月份" :labelCol="labelCol" :wrapperCol="wrapperCol"><a-month-picker v-model="endMoment" format="YYYY-MM" style="width:100%" /></a-form-item></a-col>
            <a-col :md="6" :sm="24"><a-form-item label="门店" :labelCol="labelCol" :wrapperCol="wrapperCol"><store-tenant-select domain="finance" @change="handleStoreTenantChange"></store-tenant-select></a-form-item></a-col>
            <a-col :md="6" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="searchQuery">查询</a-button>
                <a-button style="margin-left: 8px" @click="searchReset">重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <a-table bordered size="middle" rowKey="key" :columns="columns" :dataSource="tableData" :pagination="false" :loading="loading" :rowClassName="rowClassName" :scroll="tableScroll" />
    </a-card>
  </div>
</template>

<script>
import moment from 'moment'
import { ledgerAuxBalance, accountSetCurrent, auxiliaryCategoryList } from './api'
import StoreTenantSelect from '@/components/StoreTenantSelect'

const fmt2 = v => (v === null || v === undefined || v === '' || isNaN(Number(v))) ? '' : Number(v).toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
const AMOUNT_FIELDS = ['openingDebit', 'openingCredit', 'debitAmount', 'creditAmount', 'endingDebit', 'endingCredit']

export default {
  name: 'AuxBalanceList',
  components: { StoreTenantSelect },
  data() {
    return {
      labelCol: { span: 6 }, wrapperCol: { span: 17, offset: 1 },
      accountSetId: null, categoryId: undefined, dimensions: [], beginMoment: null, endMoment: null, loading: false,
      tableScroll: { x: 'max-content', y: 400 },
      list: []
    }
  },
  computed: {
    columns() {
      return [
        { title: '编码', dataIndex: 'code', width: 130 },
        { title: '名称', dataIndex: 'name' },
        { title: '期初余额', children: [
          { title: '借方', dataIndex: 'openingDebit', align: 'right', width: 110 },
          { title: '贷方', dataIndex: 'openingCredit', align: 'right', width: 110 }
        ] },
        { title: '本期发生额', children: [
          { title: '借方', dataIndex: 'debitAmount', align: 'right', width: 110 },
          { title: '贷方', dataIndex: 'creditAmount', align: 'right', width: 110 }
        ] },
        { title: '期末余额', children: [
          { title: '借方', dataIndex: 'endingDebit', align: 'right', width: 110 },
          { title: '贷方', dataIndex: 'endingCredit', align: 'right', width: 110 }
        ] }
      ]
    },
    tableData() {
      const rows = this.list.map((r, i) => {
        const row = { key: r.id || ('r' + i), code: r.code, name: r.name }
        AMOUNT_FIELDS.forEach((f) => { row[f] = fmt2(r[f]) })
        return row
      })
      if (rows.length) {
        const t = { key: '__total__', code: '', name: '合计', isTotal: true }
        AMOUNT_FIELDS.forEach((f) => { t[f] = fmt2(this.list.reduce((a, r) => a + (Number(r[f]) || 0), 0)) })
        rows.push(t)
      }
      return rows
    }
  },
  created() {
    this.beginMoment = moment()
    this.endMoment = moment()
    this.loadCurrent()
  },
  mounted() {
    this.$nextTick(() => {
      const el = this.$el.querySelector('.ant-table')
      if (el) {
        const top = el.getBoundingClientRect().top
        this.tableScroll.y = Math.max(300, window.innerHeight - top - 24)
      }
    })
  },
  methods: {
    loadCurrent() {
      accountSetCurrent({}).then((res) => {
        if (res && res.success && res.data && res.data.id) { this.accountSetId = res.data.id; this.loadCategories() } else { this.$message.warning('尚未建账') }
      })
    },
    loadCategories() {
      auxiliaryCategoryList({ accountSetId: this.accountSetId }).then((res) => {
        if (res && res.success) { this.dimensions = res.data || []; if (this.dimensions.length) { this.categoryId = this.dimensions[0].id; this.searchQuery() } }
      })
    },
    searchQuery() {
      if (!this.categoryId) { this.$message.warning('请选择辅助维度'); return }
      this.loading = true
      const beginPeriod = this.beginMoment ? this.beginMoment.format('YYYY-MM') : null
      const endPeriod = this.endMoment ? this.endMoment.format('YYYY-MM') : null
      ledgerAuxBalance({ categoryId: this.categoryId, beginPeriod: beginPeriod, endPeriod: endPeriod }).then((res) => {
        if (res && res.success) this.list = res.data || []
        else if (res && res.message) this.$message.warning(res.message)
        this.loading = false
      }).catch(() => { this.loading = false })
    },
    searchReset() { this.beginMoment = moment(); this.endMoment = moment(); this.searchQuery() },
    handleStoreTenantChange() { this.searchQuery() },
    rowClassName(record) { return record.isTotal ? 'gl-aux-total-row' : '' }
  }
}
</script>

<style scoped>
/deep/ .gl-aux-total-row td { background: #fafafa !important; font-weight: 600; }
</style>
